import React from "react";
import { observer } from "mobx-react";
import { UserAttachmentEditionUpdateStore } from "../../store";
import { UserAttachmentEditionUpdateForm } from "./UserAttachmentEditionUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type UserAttachmentEditionUpdateProps = {
  userAttachmentEditionUpdateStore: UserAttachmentEditionUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserAttachmentEditionUpdate: React.FC<UserAttachmentEditionUpdateProps> =
  observer(
    ({
      userAttachmentEditionUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={userAttachmentEditionUpdateStore.isSaving} />
          <UserAttachmentEditionUpdateForm
            userAttachmentEditionUpdateStore={userAttachmentEditionUpdateStore}
            nameError={userAttachmentEditionUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              userAttachmentEditionUpdateStore.setNameValue(value);
            }}
            name={userAttachmentEditionUpdateStore.entityValues.name}
            fileOnRestoreFile={(id: string) =>
              userAttachmentEditionUpdateStore.fileRestoreFile(id)
            }
            fileOnLoadFile={(file: any) =>
              userAttachmentEditionUpdateStore.fileUploadFile(file)
            }
            fileOnCommitFile={(changes) =>
              userAttachmentEditionUpdateStore.fileCommitFile(changes)
            }
            fileFiles={
              userAttachmentEditionUpdateStore.entityValues.__file_files
            }
            fileError={userAttachmentEditionUpdateStore.errors.file?.message}
            notesError={userAttachmentEditionUpdateStore.errors.notes?.message}
            onNotesChange={(value: string) => {
              userAttachmentEditionUpdateStore.setNotesValue(value);
            }}
            notes={userAttachmentEditionUpdateStore.entityValues.notes}
            dummyCRUDRestoredObservable={
              userAttachmentEditionUpdateStore.dummyCRUDRestoredObservable
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={userAttachmentEditionUpdateStore.saveDisabled}
            onSave={() =>
              userAttachmentEditionUpdateStore.saveUserAttachmentEdition()
            }
            onCancel={() =>
              userAttachmentEditionUpdateStore.cancelUserAttachmentEdition()
            }
          />
          <ErrorDialog
            open={userAttachmentEditionUpdateStore.errorDialogOpened}
            title={userAttachmentEditionUpdateStore.errorTitle}
            description={userAttachmentEditionUpdateStore.errorDescription}
            onClose={() => userAttachmentEditionUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={userAttachmentEditionUpdateStore.confirmDialogOpened}
            title={userAttachmentEditionUpdateStore.confirmDialogTitle}
            description={
              userAttachmentEditionUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              userAttachmentEditionUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              userAttachmentEditionUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
